<template>
    <div v-if="proofcard != ''" class="uk-text-center uk-hidden@s">
        <img :src="proofcard" alt="">
    </div>

    <img v-if="loading" src="https://via.placeholder.com/1200x200?text=LOADING" alt="" >

    <!-- Class Year Group Images -->
    <div v-if="isClass(customer.online_code) === 'class'" uk-filter="target: .js-filter">
    <!-- <div v-if="`${}`" uk-filter="target: .js-filter"> -->

        <p>Select options to filter available products</p>

        <div class="uk-grid-small uk-grid-divider uk-child-width-auto uk-margin-medium-bottom" uk-grid>
            <div>
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li class="uk-active" uk-filter-control><a href="#">All</a></li>
                </ul>
            </div>
            <div v-for="(filter_group, group_index) in classImageFilters" :key="filter_group.key">
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li
                        v-for="filter in filter_group" :key="filter.key"
                        :uk-filter-control="`filter: [data-${group_index}='${filter.filter}']; group: data-${group_index}`"
                    >
                        <a href="#" class="sp-border-light-grey">{{ filter.name }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div id="product-items" class="js-filter uk-grid-small" uk-grid>
            <div v-for="product in filteredProducts('class')" :key="product.key"
                class="sp-product-grid-item uk-width-1-1 uk-width-1-3@s uk-width-1-5@l"
                :data-classImages="product.filters['classImages']"
                @click="addProductToCart (product)"
            >
                <div class="sp-outline-small sp-border-light-grey uk-link-reset uk-card uk-card-small uk-border-rounded uk-height-1-1 uk-flex uk-flex-column uk-background-white uk-box-shadow-hover-small">
                    <div class="uk-card-media-top uk-cover-container uk-border-rounded-top">
                        <img :alt="product.package" uk-cover :data-src="product.image" :src="product.image">
                        <canvas height="400" width="800"></canvas>
                    </div>
                    <div class="uk-card-body uk-card-small uk-text-center padding-bottom-60">
                        <h3 class="uk-h3">{{ product.package }}</h3>
                        <p class="uk-text-meta uk-h5 uk-margin-remove-top"> {{ product.content }} </p>
                        <div class="uk-h4 uk-margin-remove"> {{ currency(product.price) }} </div>
                    </div>
                    <div class="uk-card-footer uk-card-small uk-text-center uk-padding-remove uk-position-bottom uk-width-1-1">
                        <button v-if="alreadyInCart(product)" disabled class="uk-button uk-button-secondary uk-width-1-1 uk-button-large border-bottom-5" type="button">Added</button>
                        <button v-else class="uk-button uk-button-primary uk-width-1-1 uk-button-large border-bottom-5" type="button">Add To Cart</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Leavers Year Group Images -->
    <div v-else-if="isClass(customer.online_code) === 'leavers'" uk-filter="target: .js-filter">
    <!-- <div v-if="`${}`" uk-filter="target: .js-filter"> -->

        <p>Select options to filter available products</p>

        <div class="uk-grid-small uk-grid-divider uk-child-width-auto uk-margin-medium-bottom" uk-grid>
            <div>
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li class="uk-active" uk-filter-control><a href="#">All</a></li>
                </ul>
            </div>
            <div v-for="(filter_group, group_index) in leaversImageFilters" :key="filter_group.key">
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li
                        v-for="filter in filter_group" :key="filter.key"
                        :uk-filter-control="`filter: [data-${group_index}='${filter.filter}']; group: data-${group_index}`"
                    >
                        <a href="#" class="sp-border-light-grey">{{ filter.name }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div id="product-items" class="js-filter uk-grid-small" uk-grid>
            <div v-for="product in filteredProducts('leavers')" :key="product.key"
                class="sp-product-grid-item uk-width-1-1 uk-width-1-3@s uk-width-1-5@l"
                :data-classImages="product.filters['classImages']"
                @click="addProductToCart (product)"
            >
                <div class="sp-outline-small sp-border-light-grey uk-link-reset uk-card uk-card-small uk-border-rounded uk-height-1-1 uk-flex uk-flex-column uk-background-white uk-box-shadow-hover-small">
                    <div class="uk-card-media-top uk-cover-container uk-border-rounded-top">
                        <img :alt="product.package" uk-cover :data-src="product.image" :src="product.image">
                        <canvas height="400" width="800"></canvas>
                    </div>
                    <div class="uk-card-body uk-card-small uk-text-center padding-bottom-60">
                        <h3 class="uk-h3">{{ product.package }}</h3>
                        <p class="uk-text-meta uk-h5 uk-margin-remove-top"> {{ product.content }} </p>
                        <div class="uk-h4 uk-margin-remove"> {{ currency(product.price) }} </div>
                    </div>
                    <div class="uk-card-footer uk-card-small uk-text-center uk-padding-remove uk-position-bottom uk-width-1-1">
                        <button v-if="alreadyInCart(product)" disabled class="uk-button uk-button-secondary uk-width-1-1 uk-button-large border-bottom-5" type="button">Added</button>
                        <button v-else class="uk-button uk-button-primary uk-width-1-1 uk-button-large border-bottom-5" type="button">Add To Cart</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Single Images / Other -->
    <div v-else uk-filter="target: .js-filter">

        <p>Select options to filter available products</p>

        <div class="uk-grid-small uk-grid-divider uk-child-width-auto uk-margin-medium-bottom" uk-grid>
            <div>
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li class="uk-active" uk-filter-control><a href="#">All</a></li>
                </ul>
            </div>
            <div v-for="(filter_group, group_index) in filters" :key="filter_group.key">
                <ul class="uk-subnav uk-subnav-pill" uk-margin>
                    <li
                        v-for="filter in filter_group" :key="filter.key"
                        :uk-filter-control="`filter: [data-${group_index}='${filter.filter}']; group: data-${group_index}`"
                    >
                        <a href="#" class="sp-border-light-grey">{{ filter.name }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div id="product-items" class="js-filter uk-grid-small" uk-grid>
            <div v-for="product in filteredProducts('single')" :key="product.key"
                class="sp-product-grid-item uk-width-1-1 uk-width-1-3@s uk-width-1-5@l"
                :data-images="product.filters['images']"
                :data-mounts="product.filters['mounts']"
                :data-extras="product.filters['extras']"
                @click="addProductToCart (product)"
            >
                <div class="sp-outline-small sp-border-light-grey uk-link-reset uk-card uk-card-small uk-border-rounded uk-height-1-1 uk-flex uk-flex-column uk-background-white uk-box-shadow-hover-small">
                    <div class="uk-card-media-top uk-cover-container uk-border-rounded-top">
                        <img :alt="product.package" uk-cover :data-src="product.image" :src="product.image">
                        <canvas height="400" width="800"></canvas>
                    </div>
                    <div class="uk-card-body uk-card-small uk-text-center padding-bottom-60">
                        <h3 class="uk-h3">{{ product.package }}</h3>
                        <p class="uk-text-meta uk-h5 uk-margin-remove-top"> {{ product.content }} </p>
                        <div class="uk-h4 uk-margin-remove"> {{ currency(product.price) }} </div>
                    </div>
                    <div class="uk-card-footer uk-card-small uk-text-center uk-padding-remove uk-position-bottom uk-width-1-1">
                        <button v-if="alreadyInCart(product)" disabled class="uk-button uk-button-secondary uk-width-1-1 uk-button-large border-bottom-5" type="button">Added</button>
                        <button v-else class="uk-button uk-button-primary uk-width-1-1 uk-button-large border-bottom-5" type="button">Add To Cart</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { currency } from "@/filters/currency"
import { mapState, mapGetters, mapActions } from "vuex"

export default {
    data() {
        return {
            loading: false,
            filters: {
                images: [
                    { filter: 'image-1', name: 'Image 1',},
                    { filter: 'image-2', name: 'Image 2',},
                    { filter: 'image-3', name: 'Image 3',},
                    { filter: 'group',   name: 'Groups',},
                    { filter: 'xmas',    name: 'Christmas',},
                ],
                mounts: [
                    { filter: 'no-mounts',   name: 'No Mounts',},
                    { filter: 'with-mounts', name: 'With Mounts',},
                    // { filter: 'framed',      name: 'Framed',},
                    // { filter: 'canvas',      name: 'Box Canvas',},
                ],
                extras: [
                    { filter: 'no',            name: 'No Addon',},
                    { filter: 'download',      name: 'Download',},
                    { filter: 'wallet-prints', name: 'Wallet Prints',},
                    { filter: 'calendar',      name: 'Calendars',},
                    { filter: 'keyrings',      name: 'Keyrings',},
                    { filter: 'xmas',          name: 'Christmas',},
                ],
            },
            classImageFilters: {
                classImages: [
                    { filter: 'class', name: 'Class',},
                ],
            },
            leaversImageFilters: {
                classImages: [
                    { filter: 'class',     name: 'Class',},
                    { filter: 'special',   name: 'Special',},
                    { filter: 'mega-pack', name: 'Mega Packs',},
                ],
            },
            image_options: {
                selected_image: 'IMG1',
                include_mounts: 'MNT0',
            }
        }
    },

    computed: {
        ...mapState({
            products: state => state.products,
            cartProducts: state => state.cart_products,
        }),
        ...mapGetters ({
            proofcard: 'proofcard',
            customer:  'customer',
        }),

    },

    methods: {
        currency,
        ...mapActions ({
            fetchProducts: 'fetchProducts',
            addProductToCart: 'addProductToCart'
        }),

        alreadyInCart (product) {
            return this.cartProducts.map(function(e) { return e.product_code; }).includes(product.product_code)
        },

        isClass (value) {
            if (value) {
                if (value.startsWith('L206-')) return 'leavers'
                if (value.startsWith('L20A-')) return 'class'
            }

            return false
        },

        filteredProducts(value) {
            return this.products.filter(product => product.type == value )
        },
    },

    created() {
        this.loading = true
        this.fetchProducts()
            .then(() => this.loading = false)
    },

};
</script>

<style>
.uk-border-rounded-top {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.sp-product-grid-item {
    min-width: 223px;
}

.sp-product-table-image {
    width: 60px;
}

.sp-product-table-td {
    padding: 0;
}

.sp-product-table-container {
    /* padding: 10px 12px 0 0; */
}

/* padding */

.padding-bottom-60 {
    padding-bottom: 60px !important;
}

/* border */
.border-bottom-5 {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.sp-border-light-grey {
    border: 1px solid #F0F0F0;
}
</style>
